/* eslint-disable no-new */
/**
 * Google Map
 *
 * Sets up Google map, plus ties it to
 * some things like sidebar buttons.
 */

/**
 * Import dependencies
 */
import { Loader } from '@googlemaps/js-api-loader';
import debounce from '../../../../components/util/debounce';
import styles from '../resort-map-styles';
import { addPins } from './map-pins';
import { handleRegionZoom } from './map-region-zoom';
import { addPoiPins } from './map-poi';

/**
 * Create map(s)
 */
document.querySelectorAll('.resort-map')?.forEach((wrap) => {
	// get this map's unique id and related data
	const { id } = wrap;
	const mapData = window[`${id}AquaminData`]; // from wp's localized data
	const mapEl = wrap.querySelector('.resort-map__topo');

	// if we have a map and pins
	if (mapEl && mapData?.pins?.length) {
		// load our map using our key
		const loader = new Loader({
			apiKey: 'AIzaSyDtt0GJiA2w7alIKx_tSDSIOU1a2V4WWY4',
			version: 'weekly',
		});

		// when ready to load the map
		loader.load().then(async () => {
			// initialize the map
			async function initMap() {
				// produce the map itself
				const { Map } = await google.maps.importLibrary('maps');
				const map = new Map(mapEl, {
					zoom: 5,
					styles,
					mapTypeControl: false,
					streetViewControl: false,
				});

				// prep for storing bounds
				const bounds = new google.maps.LatLngBounds();

				// prep for storing an info window we can reposition
				const infowindow = new google.maps.InfoWindow({
					ariaLabel: 'Marker Details',
				});

				// add resort pins
				const markers = addPins({
					google,
					map,
					mapData,
					infowindow,
					bounds,
				});

				// show all pins in frame (and again on resize)
				map.fitBounds(bounds);
				window.addEventListener(
					'resize',
					debounce(() => map.fitBounds(bounds))
				);

				// add poi pins
				addPoiPins({ google, map, mapData, infowindow });

				// zoom to regions
				handleRegionZoom({ google, map, markers, wrap });
			}

			// send it!
			initMap();
		});
	}
});
